module.exports={
	"Form": "AccountEditManifest",
	"Scope": "Account-Edit",
	"Descriptors":
	{
		"AccountDetails.Name":
		{
			"Name": "Name",
			"Hash": "Account-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Account-Edit-Identity",
				"Group": "Account-Edit-Identity"
			}
		},
		"AccountDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "Account-Edit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Account-Edit-Details",
				"Group": "Account-Edit-Details"
			}
		},
		"AccountDetails.Description":
		{
			"Name": "Description",
			"Hash": "Account-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Account-Edit-Details",
				"Group": "Account-Edit-Details"
			}
		},
		"AccountDetails.IDAccountType":
		{
			"Name": "Account Type",
			"Hash": "Account-Edit-IDAccountType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Account-Edit-Details",
				"Group": "Account-Edit-Details",
				"Entity": "AccountType",
				"SearchFields":
				[
					"Name",
					"EntityName",
					"Description"
				]
			}
		},
		"AccountDetails.EntityName":
		{
			"Name": "Entity Name",
			"Hash": "Account-Edit-EntityName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Account-Edit-Details",
				"Group": "Account-Edit-Details"
			}
		},
		"AccountDetails.IDEntity":
		{
			"Name": "IDEntity",
			"Hash": "Account-Edit-IDEntity",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Account-Edit-Details",
				"Group": "Account-Edit-Details"
			}
		},
		"AccountDetails.Balance":
		{
			"Name": "Balance",
			"Hash": "Account-Edit-Balance",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Account-Edit-Details",
				"Group": "Account-Edit-Details"
			}
		},
		"AccountDetails.Pending":
		{
			"Name": "Pending",
			"Hash": "Account-Edit-Pending",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Account-Edit-Details",
				"Group": "Account-Edit-Details"
			}
		},
		"AccountDetails.IDAccount":
		{
			"Name": "IDAccount",
			"Hash": "Account-Edit-IDAccount",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Account-Edit-DataAudit",
				"Group": "Account-Edit-DataAudit"
			}
		},
		"AccountDetails.GUIDAccount":
		{
			"Name": "GUIDAccount",
			"Hash": "Account-Edit-GUIDAccount",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Account-Edit-DataAudit",
				"Group": "Account-Edit-DataAudit"
			}
		},
		"AccountDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Account-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Account-Edit-DataAudit",
				"Group": "Account-Edit-DataAudit"
			}
		},
		"AccountDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Account-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Account-Edit-DataAudit",
				"Group": "Account-Edit-DataAudit"
			}
		},
		"AccountDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Account-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Account-Edit-DataAudit",
				"Group": "Account-Edit-DataAudit"
			}
		},
		"AccountDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Account-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Account-Edit-DataAudit",
				"Group": "Account-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Account-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Account-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Account-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Account-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Account-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Account-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
